class CollectionActivityFilter extends HTMLElement {
  connectedCallback() {
    // Shopify omits active values that have no published products.
    const selectedValues = new URLSearchParams(window.location.search).getAll(this.dataset.filterName).flatMap(value => value.split(','));

    this.querySelectorAll('[data-activity-value]').forEach(link => {
      const active = link.dataset.activityValue ? selectedValues.includes(link.dataset.activityValue) : selectedValues.length === 0;
      link.classList.toggle('is-active', active);

      if (active) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('collection-activity-filter')) {
  customElements.define('collection-activity-filter', CollectionActivityFilter);
}
